// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3IYyv","title":"Header_title__16ogF","left":"Header_left__V8IDR","clinicName":"Header_clinicName__3W95V"};